(() => {
  // app/scripts/common/function/addEvent.js
  function addEvent(evt, selector, handler) {
    evt.split(" ").forEach((event) => {
      document.addEventListener(event, function(event2) {
        if (event2.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event2.target.closest(selector), arguments);
        }
      }, false);
    });
  }

  // app/scripts/common/function/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/common/index.js
  window.theme = Object.assign(window.theme || {}, {
    addEvent,
    debounceTime
  });

  // app/scripts/common/events/toggleClass.js
  var { addEvent: addEvent2 } = theme;
  addEvent2("click", ".jsToggleClass", (e) => {
    const el = e.target.closest(".jsToggleClass");
    const target = document.querySelectorAll(el.dataset.target || null);
    if (!target.length)
      return;
    let { className, classRemove, classRule, classEvent } = el.dataset;
    if (!className) {
      className = "active";
    }
    if (classEvent == "none") {
      e.preventDefault();
      e.stopPropagation();
    }
    target.forEach((i) => {
      switch (classRule) {
        case "add":
          i.classList.add(...className.split(","));
          break;
        case "remove":
          i.classList.remove(...className.split(","));
          break;
        default:
          className.split(",").forEach((c) => i.classList.toggle(c));
          break;
      }
      if (classRemove) {
        i.classList.remove(...classRemove.split(","));
      }
      i.className.includes("header-search") && document.querySelector("header predictive-search")?.focusSearch();
    });
  });

  // app/scripts/common/events/loadTemplate.js
  var { addEvent: addEvent3 } = theme;
  addEvent3("click", ".js-tload", (e) => {
    const node = e.target.closest(".js-tload");
    const template = document.querySelector(node.dataset.tload);
    e.preventDefault();
    e.stopPropagation();
    template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
      template.insertAdjacentElement("beforebegin", child);
    });
    if (template.tagName == "NOSCRIPT") {
      const div = document.createElement("div");
      div.innerHTML = template.innerHTML;
      template.insertAdjacentElement("beforebegin", div);
    }
    template.remove();
    node.classList.remove("js-tload");
    node.removeAttribute("data-tload");
    theme.actionQueue && theme.actionQueue.length && setTimeout(() => {
      theme.actionQueue.forEach((i, index) => {
        i.el.dispatchEvent(new Event(i.event));
        i.event == "click" && i.el.click();
        theme.actionQueue.splice(index, 1);
      });
    }, 300);
  });

  // app/scripts/common/events/togglePopup.js
  var { addEvent: addEvent4, loadTemplate } = theme;
  addEvent4("click", ".js-popup-toggle", async (e) => {
    const el = e.target.closest(".js-popup-toggle");
    if (el.classList.contains("js-tload")) {
      await loadTemplate(el);
      if (el.classList.contains("btn__mobile")) {
        const popupStore = document.querySelector("popup-select-store");
        const markers = popupStore.loadMarkers();
        popupStore.displayPopupStore(null, markers);
      }
    }
    const popup = document.querySelector(el.dataset.control);
    if (!popup)
      return;
    popup.tagName.toLowerCase().includes("popup") && popup.toggle((resp) => {
      el.classList.toggle("active", resp?.isActive || false);
    });
  });

  // app/scripts/common/component/popupComponent.js
  customElements.define("popup-component", class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("keydown", (e) => {
        if (e.keyCode === 27) {
          this.close();
        }
      });
    }
    connectedCallback() {
      let className = this.dataset.className?.split(",") || [];
      className.push("active");
      this.classes = {
        className
      };
      this.addEventListener("click", (e) => {
        const currentTarget = e.target;
        if (!currentTarget.closest(".popup__content") && !currentTarget.closest(".jsContent") || currentTarget.closest(".jsClose"))
          this.close();
      });
      this.appendDocument();
      this.autoShow();
    }
    close() {
      this.classList.remove(...this.classes.className);
      this.setAttribute("aria-hidden", true);
      if (!document.querySelectorAll('popup-component:not([aria-hidden="true"])').length)
        document.body.classList.remove("show-popup");
      this.isActive = null;
      this.focusedElementBeforeModal.focus();
    }
    open(callback = null) {
      this.focusedElementBeforeModal = document.activeElement;
      this.classList.add(...this.classes.className);
      this.setAttribute("aria-hidden", false);
      this.autoHide();
      if (!this.classList.contains("compare-popup")) {
        document.body.classList.add("show-popup");
      }
      this.isActive = true;
      setTimeout(() => {
        const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        this.querySelectorAll(focusableElementsString).length && this.querySelectorAll(focusableElementsString)[0].focus();
      }, 100);
      callback && callback();
    }
    toggle(callback = null) {
      this.isActive ? this.close() : this.open();
      callback && callback(this.isActive);
    }
    appendDocument() {
      if (!this.hasAttribute("append-body"))
        return;
      this.removeAttribute("append-body");
      const existingNode = document.getElementById(this.id);
      if (existingNode && existingNode !== this) {
        existingNode.after(this);
        existingNode.remove();
      }
    }
    autoShow() {
      if (!this.hasAttribute("append-auto"))
        return;
      this.removeAttribute("append-auto");
      setTimeout(() => {
        this.open();
      }, 300);
    }
    autoHide() {
      if (!this.hasAttribute("auto-hide"))
        return;
      if (this.isHiding != null)
        clearTimeout(this.isHiding);
      this.isHiding = setTimeout(() => {
        this.close();
        this.isHiding = null;
      }, +this.getAttribute("auto-hide"));
    }
  });
})();
